import React from 'react';

function ImageIcon() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H19C19.7956 21 20.5587 20.6839 21.1213 20.1213C21.6839 19.5587 22 18.7956 22 18V6C22 5.20435 21.6839 4.44129 21.1213 3.87868C20.5587 3.31607 19.7956 3 19 3ZM5 19C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V15.58L7.3 12.29C7.48693 12.1068 7.73825 12.0041 8 12.0041C8.26175 12.0041 8.51307 12.1068 8.7 12.29L15.41 19H5ZM20 18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H18.23L14.42 15.17L15.3 14.29C15.4869 14.1068 15.7382 14.0041 16 14.0041C16.2618 14.0041 16.5131 14.1068 16.7 14.29L20 17.58V18ZM20 14.76L18.12 12.89C17.5501 12.3424 16.7904 12.0366 16 12.0366C15.2096 12.0366 14.4499 12.3424 13.88 12.89L13 13.77L10.12 10.89C9.55006 10.3424 8.79036 10.0366 8 10.0366C7.20964 10.0366 6.44994 10.3424 5.88 10.89L4 12.76V6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5H19C19.2652 5 19.5196 5.10536 19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V14.76Z'
        fill='#565F67'
      />
    </svg>
  );
}

export default ImageIcon;
